
export const parseQuote = (quoteText) => {
    try {
        return JSON.parse(atob(quoteText))
    }
    catch (e) {
        return {}
    }
}